/**
 * @file: 刷新
 * @author: xiaolong.huang@dmall.com
 */

import { StageEvent } from '../../message/index';
import { isLocalSystem } from '../../stageStatus/index';

function trigger(): void {
    // 用于本地调试
    if (isLocalSystem()) {
        window.location.reload();
        return;
    }

    StageEvent.fire('refresh', {
        eventFrom: 'stage'
    });
}

export default {
    trigger
};
